module.exports = __webpack_public_path__ + "img/txt_info2.b2294687.png";